import React from 'react';
import { DataFieldToDisplay } from 'src/components-bl/EmailMarketing/constants/data-fields-to-display';
import { DataFieldSelector } from '../DataFieldSelector';
import {
  AvailableIcons,
  Typography,
  TypographyVariant,
  Icon,
  TypographyType,
} from 'src/components-dummy';
import {
  CardTitleStyled,
  DeleteButtonStyled,
  ButtonsContainer,
  CardTitleContainer,
  MoveButtonStyled,
  IconStyled,
} from './ProductCardSection.styles';
import { LinkButton } from 'src/components-dummy/LinkButton';
import { SectionStyled } from '../EmailDisplaySettingsSection.styles';
import {
  ProductCardConfig,
  WidgetMaker,
} from 'src/components-bl/EmailMarketing/types/widget-maker';
import { FontStyles } from '../FontStyles';
import { getErrorMessage } from 'src/components-bl/EmailMarketing/get-error-message';
import { ParseJoiValidateResponse } from 'src/utils';

interface DraggableCardProps {
  field: DataFieldToDisplay;
  index: number;
  dataFieldsDropdownOptions: DataFieldToDisplay[];
  handleSelectChange: (index: number, item: DataFieldToDisplay) => void;
  handleStyleChange: (field: string, value: any, index: number) => void;
  onRemove: (index: number) => void;
  onAdd: () => void;
  isLastCard: boolean;
  isFirstCard: boolean;
  onMoveCard: (index: number, direction: 'up' | 'down') => void;
  productCardConfig: ProductCardConfig;
  errors: ParseJoiValidateResponse<WidgetMaker>;
}

export const DraggableCard = ({
  field,
  index,
  dataFieldsDropdownOptions,
  handleSelectChange,
  handleStyleChange,
  onRemove,
  onAdd,
  isLastCard,
  isFirstCard,
  onMoveCard,
  productCardConfig,
  errors,
}: DraggableCardProps): JSX.Element => {
  return (
    <SectionStyled key={field.id}>
      <CardTitleContainer>
        <CardTitleStyled type={TypographyType.Body} variant={TypographyVariant.SmallBold}>
          {`Product Card Field #${index + 1}`}
        </CardTitleStyled>
        {isFirstCard && isLastCard ? null : (
          <MoveButtonStyled>
            <Typography type={TypographyType.Body} variant={TypographyVariant.SmallRegular}>
              Move
            </Typography>
            {[
              !isLastCard && (
                <IconStyled
                  name={AvailableIcons.ArrowRounded}
                  rotateDegrees={90}
                  onClick={() => onMoveCard(index, 'down')}
                />
              ),
              !isFirstCard && (
                <IconStyled
                  name={AvailableIcons.ArrowRounded}
                  rotateDegrees={-90}
                  onClick={() => onMoveCard(index, 'up')}
                />
              ),
            ]}
          </MoveButtonStyled>
        )}
      </CardTitleContainer>
      <DataFieldSelector
        field={field}
        index={index}
        dataFieldsDropdownOptions={dataFieldsDropdownOptions}
        handleSelectChange={handleSelectChange}
      />
      <FontStyles
        config={productCardConfig}
        onChange={handleStyleChange}
        index={index}
        getErrorMessage={fieldKey => getErrorMessage(errors, 'productCard', fieldKey, index)}
      />
      <ButtonsContainer>
        {isLastCard ? (
          <LinkButton onClick={onAdd}>
            <Icon name={AvailableIcons.Plus} /> Add another Field
          </LinkButton>
        ) : null}
        <DeleteButtonStyled onClick={() => onRemove(field.position)}>
          <Icon name={AvailableIcons.TrashCan} />
          <Typography type={TypographyType.Body} variant={TypographyVariant.MediumMedium}>
            Delete Field
          </Typography>
        </DeleteButtonStyled>
      </ButtonsContainer>
    </SectionStyled>
  );
};
